export { default } from './SectionHeading'
